import React from 'react'
import PropTypes from 'prop-types'
import InputLine from 'client/components/InputLine'
import styles from './styles.module.css'

const Accordion = ({ sections, selectedSectionId, onChange }) => {
  function isSelected(id) {
    return selectedSectionId === id
  }

  return (
    <section className={styles.accordion}>
      {sections.map(({ id, title, body }) => (
        <summary
          aria-expanded={isSelected(id)}
          className={styles.container}
          key={id}
          data-testid={`section-${id}`}
          onClick={() => onChange(id)}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              onChange(id)
              event.preventDefault()
            }
          }}
          tabIndex={0}
        >
          <div className={`${styles.title} ${isSelected(id) && styles.active}`}>
            <InputLine
              checked={isSelected(id)}
              label={title}
              name={id}
              type="radio"
              value={id}
              readOnly
            />
          </div>
          {isSelected(id) && <div className={styles.body}>{body}</div>}
        </summary>
      ))}
    </section>
  )
}

Accordion.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.node,
      body: PropTypes.node,
    })
  ).isRequired,
  selectedSectionId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default Accordion
